import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { QuestionCircle } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';

const TOOLTIP_TEXT = 'How relative strength works';

/** Desktop title control: hover tooltip + click opens the methodology modal. */
export default function RelativeStrengthInfoButton({ onClick }) {
  const { colors } = useTheme();

  return (
    <OverlayTrigger
      placement="right"
      overlay={<Tooltip id="relative-strength-title-tooltip">{TOOLTIP_TEXT}</Tooltip>}
    >
      <button
        type="button"
        data-testid="relative-strength-title-info"
        aria-label={TOOLTIP_TEXT}
        onClick={onClick}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          margin: 0,
          padding: 0,
          border: 'none',
          borderRadius: 8,
          background: 'transparent',
          color: colors.textMuted,
          cursor: 'pointer',
        }}
      >
        <QuestionCircle size={18} />
      </button>
    </OverlayTrigger>
  );
}
